var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-header one-liner"},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }